// src/services/GeocercaService.js
import fetch from 'auth/FetchInterceptor';

const GeocercaService = {};

GeocercaService.getAll = function (params = {}) {
    return fetch({
        url: '/v1/geocercas',
        method: 'get',
        params,
    });
};

GeocercaService.getById = function (id) {
    return fetch({
        url: `/v1/geocercas/${id}`,
        method: 'get',
    });
};

GeocercaService.create = function (data) {
    return fetch({
        url: '/v1/geocercas',
        method: 'post',
        data,
    });
};

GeocercaService.update = function (id, data) {
    return fetch({
        url: `/v1/geocercas/${id}`,
        method: 'put',
        data,
    });
};

GeocercaService.remove = function (id) {
    return fetch({
        url: `/v1/geocercas/${id}`,
        method: 'delete',
    });
};

GeocercaService.updateEstado = function (id, activa) {
    return fetch({
        url: `/v1/geocercas/${id}/estado`,
        method: 'patch',
        data: { activa },
    });
};

GeocercaService.validar = function (empleadoId, lat, lng) {
    return fetch({
        url: '/v1/geocercas/validar',
        method: 'post',
        data: { empleado_id: empleadoId, lat, lng },
    });
};

GeocercaService.getByEmpresa = function (empresaId, params = {}) {
    return fetch({
        url: `/v1/empresas/${empresaId}/geocercas`,
        method: 'get',
        params,
    });
};

GeocercaService.getEmpleados = function (id) {
    return fetch({
        url: `/v1/geocercas/${id}/empleados`,
        method: 'get',
    });
};

GeocercaService.asignarEmpleados = function (id, empleadoIds) {
    return fetch({
        url: `/v1/geocercas/${id}/empleados`,
        method: 'post',
        data: { empleado_ids: empleadoIds },
    });
};

export default GeocercaService;
